// extracted by mini-css-extract-plugin
export default {"component":"bh1iNc","componentSmall":"ch1iNc","headline":"dh1iNc","headlineIcon":"eh1iNc","smallIcon":"fh1iNc"};